import { BotMessageSquare } from "lucide-react";
import type { ReactNode } from "react";
import { Card, CardContent, CardFooter, CardHeader } from "../ui/card";

export interface ErrorDisplayProps {
  footer?: ReactNode;
  title?: string | null;
  message?: string | null;
}

export function ErrorDisplay({
  footer,
  title = "Oops! Something went wrong",
  message = "We apologize for the inconvenience. Our team has been notified and is working to fix the issue.",
}: ErrorDisplayProps) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md border-none shadow-none">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex items-center justify-center rounded-full bg-accent p-4">
            <BotMessageSquare className="mx-auto size-12 stroke-[1.25]" />
          </div>
          <h2 className="text-2xl font-medium">{title}</h2>
        </CardHeader>
        <CardContent>
          <p className="text-center text-muted-foreground">{message}</p>
        </CardContent>
        {footer ? (
          <CardFooter className="flex justify-center">{footer}</CardFooter>
        ) : null}
      </Card>
    </div>
  );
}
